import axios from 'axios';
import config from '../config';

const getAuthToken = () => localStorage.getItem('token') || '';

const getBaseURL = () => {
  if (!config.baseApi) {
    throw new Error('REACT_APP_BASE_URL is not defined');
  }
  return config.baseApi;
};

const api = axios.create({
  baseURL: getBaseURL(),
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 🔐 Attach token to every request
api.interceptors.request.use(
  (requestConfig) => {
    const token = getAuthToken();
    if (token) {
      requestConfig.headers.Authorization = `Bearer ${token}`;
    }
    return requestConfig;
  },
  (error) => Promise.reject(error)
);

// 🚨 Handle expired / invalid token globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn('🔒 Token expired or invalid. Logging out...');

      // 1. Remove token
      localStorage.removeItem('token');

      // 2. Save message for login page
      localStorage.setItem(
        'auth_error',
        'Your session has expired. Please sign in again.'
      );

      // 3. Redirect to login
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export { api, getAuthToken };
